export default "__VITE_ASSET__393eb1ce__"